import Link from 'next/link';
import { Url } from '../types';
import { RefObject, forwardRef } from 'react';

interface Props {
  label: string;
  url: Url;
  styles?: string;
  type?: 'top' | 'main' | 'search';
  uppercase?: boolean;
  hoverMainMenuEffect?: boolean;
  hoverTopMenuEffect?: boolean;
  hoverSubMenuEffect?: boolean;
  prefetch?: boolean;
  onClick?: () => void;
  ref?: RefObject<HTMLAnchorElement>;
}

const MenuLink = forwardRef<HTMLAnchorElement, Props>(
  (
    {
      label,
      url,
      styles,
      type = 'top',
      hoverMainMenuEffect = false,
      hoverTopMenuEffect = false,
      hoverSubMenuEffect = false,
      onClick,
      prefetch = true,
    },
    ref,
  ) => {
    const target = url.external ? '_blank' : '_self';
    const linkHref = url.url + (url.slug ? `${url.slug}` : '');

    const family =
      type === 'main'
        ? `font-AgencyFBBlackCond antialiased text-xl tracking-wide`
        : `font-Manrope font-bold antialiased tracking-tight`;

    const hoverClasses = [
      hoverMainMenuEffect && 'hover-text-important',
      hoverTopMenuEffect && 'hover:animate-quickBounce',
    ]
      .filter(Boolean)
      .join(' ');

    if (!url.url) {
      return (
        <div
          className={`relative ${family} ${styles} cursor-pointer`}
        >
          {label}
        </div>
      );
    }

    return (
      <Link
        href={linkHref}
        prefetch={prefetch || false}
        className={`relative ${family} ${styles} ${hoverClasses} hover:bg-transparent focus:bg-inherit active:bg-inherit`}
        tabIndex={0}
        target={target}
        style={{ textDecoration: 'none' }}
        onClick={onClick}
        ref={ref}
      >
        <span className={hoverSubMenuEffect ? 'hover:gradient-text' : ''}>{label}</span>
      </Link>
    );
  },
);

MenuLink.displayName = 'MenuLink';

export default MenuLink;